import API from "@/models/API";

export default class ProductPerStore {
    constructor(item = {}) {
        
    }

    static get = (query) =>
        API.get(
            `/companies/${localStorage.getItem("storeId")}/stores/products${query}`
        );

    static getStores = (query) =>
        API.get(
            `/companies/${localStorage.getItem("storeId")}/products/store-products/stores${query}`
        );

    static getProducts = (query) =>
        API.get(
            `/companies/${localStorage.getItem("storeId")}/products/store-products/products${query}`
        );

    static updateCheckbox = (body) =>
        API.put(
            `/companies/${localStorage.getItem("storeId")}/products/store-products/${body.stores_store_id}/products/${body.parent_product_id}`
        );

    static addRemoveAll = (body) =>
        API.put(
            `/companies/${localStorage.getItem("storeId")}/products/store-products/products`,
            body
        );
}
